import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Table, Badge, Btn } from "@/components/erp/ui";
import { toast } from "sonner";

export const RaisesTab = () => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/raises").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const decide = async (id, approve) => {
    try { await api.post(`/raises/${id}`, { approve }); toast.success(approve ? "Gaji pokok dinaikkan" : "Usulan ditolak"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  return (
    <Table testid="raises-table" columns={["Karyawan", "Ulang Tahun Kerja", "Rata-rata Nilai 12 Bln", "Gaji Pokok", "Usulan", "Status", ""]} rows={rows} renderRow={(r) => (
      <tr key={r.employee_id} data-testid={`raise-row-${r.employee_id}`} className="border-b border-slate-100 last:border-0">
        <td className="px-4 py-3 font-medium">{r.name}<div className="text-[10px] text-slate-400">masuk {r.join_date} · {r.years} thn</div></td>
        <td className="px-4 py-3 text-xs">{r.anniversary}{!r.due && <div className="text-amber-600">akan datang</div>}</td>
        <td className={`px-4 py-3 font-semibold ${r.eligible ? "text-emerald-600" : "text-rose-600"}`}>{r.avg_perf}<span className="text-xs text-slate-400"> / min {r.min_avg}</span></td>
        <td className="px-4 py-3">{formatIDR(r.basic_salary)}</td>
        <td className="px-4 py-3">{r.eligible ? <>{formatIDR(r.proposed_salary)} <span className="text-xs text-emerald-600">+{r.raise_pct}%</span></> : <span className="text-xs text-rose-500">Tidak naik gaji / tunjangan rutin</span>}</td>
        <td className="px-4 py-3"><Badge>{r.status}</Badge></td>
        <td className="px-4 py-3 text-right whitespace-nowrap">
          {r.due && r.status === "PROPOSED" && <Btn data-testid={`raise-approve-${r.employee_id}`} onClick={() => decide(r.employee_id, true)}>Setujui</Btn>}
          {r.due && ["PROPOSED", "NOT_ELIGIBLE"].includes(r.status) && <Btn variant="ghost" data-testid={`raise-reject-${r.employee_id}`} onClick={() => decide(r.employee_id, false)}>Tolak</Btn>}
        </td>
      </tr>
    )} />
  );
};
